import { z } from "zod";

import { ProjectData } from "../../../../models/ProjectData";

export const schema = z.object({
  customNotes: z.string().optional()
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (project?: ProjectData): Schema => {
  return {
    customNotes: project?.custom_notes ?? ""
  };
};
